import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { formatKilos } from '@/lib/utils'
import type { KilosByDestination } from '@/types'

interface Props {
  data: KilosByDestination[] | undefined
  isLoading: boolean
}

function buildChartData(data: KilosByDestination[]) {
  const valorizadores: Record<string, number> = {}
  const acopios: Record<string, number> = {}

  for (const d of data) {
    if (d.is_valorizer) valorizadores[d.destination_name] = d.kg
    else acopios[d.destination_name] = d.kg
  }

  const names = Array.from(new Set(data.map((d) => d.destination_name)))
  return names.map((name) => ({
    name,
    Valorizador: valorizadores[name] ?? 0,
    'Punto de acopio': acopios[name] ?? 0,
  }))
}

export function DestinationChart({ data, isLoading }: Props) {
  const chartData = buildChartData(data ?? [])

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm font-medium">Kg por destino final</CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="h-64 animate-pulse rounded-md bg-gray-100" />
        ) : (
          <ResponsiveContainer width="100%" height={260}>
            <BarChart data={chartData} margin={{ bottom: 16 }}>
              <XAxis dataKey="name" tick={{ fontSize: 11 }} />
              <YAxis tickFormatter={(v) => formatKilos(v)} tick={{ fontSize: 11 }} />
              <Tooltip formatter={(v) => [formatKilos(v as number), 'kg']} />
              <Legend />
              <Bar dataKey="Valorizador" fill="#7c8c43" radius={[4, 4, 0, 0]} />
              <Bar dataKey="Punto de acopio" fill="#b9d94a" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  )
}
